<template>
    <div class="space-y-4">
        <UFormGroup label="Message Body" required>
            <UTextarea
                :model-value="modelValue?.body ?? ''"
                @update:model-value="patch({ body: $event })"
                :rows="5"
                autoresize
            />
        </UFormGroup>
        <div class="flex items-center justify-between text-xs text-gray-400">
            <span>Merge tags: &#123;&#123;first_name&#125;&#125;, &#123;&#123;last_name&#125;&#125;, &#123;&#123;full_name&#125;&#125;, &#123;&#123;policy_holder&#125;&#125;</span>
            <span>{{ charCount }} chars &middot; {{ segmentCount }} segment{{ segmentCount !== 1 ? 's' : '' }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
const props = defineProps<{ modelValue: any }>()
const emit = defineEmits<{ 'update:modelValue': [any] }>()

function patch(partial: Record<string, any>) {
    emit('update:modelValue', { ...(props.modelValue ?? {}), ...partial })
}

const charCount = computed(() => (props.modelValue?.body ?? '').length)
const segmentCount = computed(() => Math.ceil(charCount.value / 160) || 1)
</script>
